import script from "./JoinCampaignBulk.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinCampaignBulk.vue?vue&type=script&setup=true&lang=js"

import "./JoinCampaignBulk.vue?vue&type=style&index=0&id=b42b9d92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b42b9d92"]])

export default __exports__